// extracted by mini-css-extract-plugin
export var caption = "bm_f9";
export var grey = "bm_c2";
export var heading = "bm_G";
export var image = "bm_k";
export var left = "bm_b8";
export var reverse = "bm_cZ";
export var right = "bm_ck";
export var section = "bm_j";
export var video = "bm_gb";
export var videoContainer = "bm_bs";
export var videoWrapper = "bm_bt";